// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__2j1qM","alertText":"Alert_alertText__3vsAD","error":"Alert_error__3ZIRi"};